export const daysOrder = {
  1: 'mn',
  2: 'tu',
  3: 'wd',
  4: 'th',
  5: 'fr',
  6: 'st',
  7: 'sn',
}

export const SCHEDULES_SET = 'SCHEDULES_SET'
export const SCHEDULES_DELETE_SUCCESS = 'SCHEDULES_DELETE_SUCCESS'
